<template>
  <div>
    <QueryFrame
      :disablePage='true'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>医保查询目录:</label>
              <lk-radio-group v-model="query.type" @on-change='handlerChange'>
                <lk-radio v-for="item in directoryList" :label="item.id" :key="item.id">
                  <span>{{item.name}}</span>
                </lk-radio>
              </lk-radio-group>
          </div>
          <br/>
        </div>
        <div class="queryContainer">
          <div class="queryItem">
            <label class="requireStar">医疗目录编码:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.medListCodg"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="toSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-card title='查询结果'>
          <lk-tabs :value="config.currentTab">
            <lk-tab-pane label='医保目录限价信息' name='limitedPrice'>
              <div class="con">
                <div v-for="(item, index) in limitedPriceList" :key="index" class="everyInfo">
                  <lk-tooltip transfer placement="top-start">
                    <div slot='content' style="whiteSpace: normal;wordWrap: break-word;">
                        {{limitedPriceObj[item.key]}}
                    </div>
                    {{`${item.title} : ${limitedPriceObj[item.key] ? limitedPriceObj[item.key] : ""}`}}
                  </lk-tooltip>
                </div>
              </div>
            </lk-tab-pane>
            <lk-tab-pane label='医保目录自负比例信息' name='selfPercent'>
              <div class="con">
                <div v-for="(item, index) in selfPercentArray" :key="index">
                  <div v-for="(subItem, idx) in selfPercentList" :key="idx" class="everyInfo">
                    <lk-tooltip transfer placement="top-start">
                      <div slot='content' style="whiteSpace: normal;wordWrap: break-word;">
                          {{item[subItem.key]}}
                      </div>
                      {{`${subItem.title} : ${item[subItem.key] ? item[subItem.key] : ""}`}}
                    </lk-tooltip>
                  </div>
                  <lk-divider/>
                </div>
              </div>
            </lk-tab-pane>
            <lk-tab-pane label='医保目录信息' name='insDirectory'>
              <div class="con">
                <div v-for="(item, index) in insDirectoryList" :key="index" class="everyInfo">
                  <lk-tooltip transfer placement="top-start">
                    <div slot='content' style="whiteSpace: normal;wordWrap: break-word;">
                        {{insDirectoryObj[item.key]}}
                    </div>
                    {{`${item.title} : ${insDirectoryObj[item.key] ? insDirectoryObj[item.key] : ""}`}}
                  </lk-tooltip>
                </div>
              </div>
            </lk-tab-pane>
            <lk-tab-pane :label='config.drugLableName' name='drug' >
              <div class="con">
                <div v-for="(item, index) in config.drugList" :key="index" class="everyInfo">
                  <lk-tooltip transfer placement="top-start">
                    <div slot='content' style="whiteSpace: normal;wordWrap: break-word;">
                      {{config.drugObj[item.key]}}
                    </div>
                    {{`${item.title} : ${config.drugObj[item.key] ? config.drugObj[item.key] : ""}`}}
                  </lk-tooltip>
                </div>
              </div>
            </lk-tab-pane>
          </lk-tabs>
        </lk-card>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import utils from '@/libs/utils.js';
import healthInsManage from '@/services/healthInsManage';

export default {
  name: 'HLJDrugInfoSearch',
  components: {
    QueryFrame,
  },
  props: {},
  data() {
    return {
      config: {
        currentTab: 'limitedPrice',
        drugObj: {},
        drugLableName: '西药药品目录信息',
        drugList: [],
      },
      directoryList: [
        {
          id: 1,
          name: '西药药品目录',
        },
        {
          id: 3,
          name: '中草药药品目录',
        },
        {
          id: 2,
          name: '耗材目录',
        },
      ],
      query: {
        medListCodg: null,
        type: 1,
      },
      drugInfo: {},
      // 医保目录限价信息【11301】西药药品目录查询【11302】中草药药品目录查询【11305】耗材目录查询
      limitedPriceList: [
        {
          title: '医保目录编码',
          key: 'hilistCode',
        },
        {
          title: '医保目录限价',
          key: 'hilistLmtpri',
        },
        {
          title: '类型',
          key: 'cType',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '参保所属医保区划',
          key: 'insuAdmdvs',
        },
        {
          title: '表名',
          key: 'tabname',
        },
        {
          title: '医保目录超限处理方式',
          key: 'overlmtDspoWay',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '医保目录定价上限金额',
          key: 'hilistPricUplmtAmt',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
      ],
      limitedPriceObj: {},
      // 医保目录自付比例信息【11301】西药药品目录查询【11302】中草药药品目录查询【11305】耗材目录查询
      selfPercentList: [
        {
          title: '医保目录编码',
          key: 'hilistCode',
        },
        {
          title: '医保目录自付比例人员类别',
          key: 'selfpayPropPsnType',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '参保所属医保区划',
          key: 'insuAdmdvs',
        },
        {
          title: '表名',
          key: 'tabname',
        },
        {
          title: '目录自付比例类别',
          key: 'selfpayPropType',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '自付比例',
          key: 'selfpayProp',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
      ],
      selfPercentArray: [],
      // 医保目录信息【11301】西药药品目录查询【11302】中草药药品目录查询
      insDirectoryList: [
        {
          title: '医保目录编码',
          key: 'hilistCode',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '参保机构医保区划',
          key: 'insuAdmdvs',
        },
        {
          title: '医保目录名称',
          key: 'hilistName',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '医疗收费项目类别',
          key: 'medChrgitmType',
        },
        {
          title: '收费项目等级',
          key: 'chrgitmLv',
        },
        {
          title: '限制使用标志',
          key: 'lmtUsedFlag',
        },
        {
          title: '目录类别',
          key: 'listType',
        },
        {
          title: '医疗使用标志',
          key: 'medUseFlag',
        },
        {
          title: '生育使用标志',
          key: 'matnUsedFlag',
        },
        {
          title: '医保目录使用类别',
          key: 'hilistUseType',
        },
        {
          title: '限复方使用类型',
          key: 'lmtCpndType',
        },
        {
          title: '五笔助记码',
          key: 'wubi',
        },
        {
          title: '拼音助记码',
          key: 'pinyin',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
        {
          title: '统筹区',
          key: 'poolareaNo',
        },
      ],
      insDirectoryObj: {},
      // 西药药品目录信息【11301】西药药品目录查询
      drugList: [
        {
          title: '医疗目录编码',
          key: 'medListCodg',
        },
        {
          title: '药品商品名',
          key: 'drugProdname',
        },
        {
          title: '通用名编码',
          key: 'gennameCodg',
        },
        {
          title: '药品通用名',
          key: 'drugGenname',
        },
        {
          title: '化学名称',
          key: 'chemname',
        },
        {
          title: '别名',
          key: 'alis',
        },
        {
          title: '英文名称',
          key: 'engName',
        },
        {
          title: '注册名称',
          key: 'regName',
        },
        {
          title: '药品本位码',
          key: 'drugstdcode',
        },
        {
          title: '药品剂型',
          key: 'drugDosform',
        },
        {
          title: '药品剂型名称',
          key: 'drugTypeName',
        },
        {
          title: '药品规格',
          key: 'drugSpec',
        },
        {
          title: '药品规格代码',
          key: 'drugSpecCode',
        },
        {
          title: '注册剂型',
          key: 'regDosform',
        },
        {
          title: '注册规格',
          key: 'regSpec',
        },
        {
          title: '注册规格代码',
          key: 'regSpecCode',
        },
        {
          title: '国家药品编号',
          key: 'natDrugNo',
        },
        {
          title: '中成药标志',
          key: 'tcmpatFlag',
        },
        {
          title: '生产地类别名称',
          key: 'prodplacTypeName',
        },
        {
          title: '计价单位类型',
          key: 'prcuntType',
        },
        {
          title: '非处方药标志名称',
          key: 'otcFlagName',
        },
        {
          title: '包装材质名称',
          key: 'pacmatlName',
        },
        {
          title: '包装规格',
          key: 'pacspec',
        },
        {
          title: '包装数量',
          key: 'pacCnt',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '最小使用单位',
          key: 'minUseunt',
        },
        {
          title: '最小销售单位',
          key: 'minSalunt',
        },
        {
          title: '最小计量单位',
          key: 'minUnt',
        },
        {
          title: '最小包装数量',
          key: 'minPacCnt',
        },
        {
          title: '最小包装单位',
          key: 'minPacunt',
        },
        {
          title: '最小制剂单位',
          key: 'minPrepunt',
        },
        {
          title: '最小包装单位名称',
          key: 'minpacuntName',
        },
        {
          title: '最小制剂单位名称',
          key: 'minPrepuntName',
        },
        {
          title: '药品有效期',
          key: 'drugExpy',
        },
        {
          title: '最小计价单位',
          key: 'minPrcunt',
        },
        {
          title: '五笔助记码',
          key: 'wubi',
        },
        {
          title: '拼音助记码',
          key: 'pinyin',
        },
        {
          title: '分包装厂家',
          key: 'subpckFcty',
        },
        {
          title: '生产企业代码',
          key: 'prodentpCode',
        },
        {
          title: '生产企业名称',
          key: 'prodentpName',
        },
        {
          title: '特殊限价药品标志',
          key: 'spLmtpricDrugFlag',
        },
        {
          title: '特殊药品标志',
          key: 'spDrugFlag',
        },
        {
          title: '限制使用范围',
          key: 'lmtUsescp',
        },
        {
          title: '限制使用标志',
          key: 'lmtUsedFlag',
        },
        {
          title: '药品注册证编号',
          key: 'drugRegno',
        },
        {
          title: '药品注册证号开始日期',
          key: 'drugRegcertBegndate',
        },
        {
          title: '药品注册证号结束日期',
          key: 'drugRegcertEnddate',
        },
        {
          title: '批准文号',
          key: 'aprvno',
        },
        {
          title: '批准文号开始日期',
          key: 'aprvnoEnddate',
        },
        {
          title: '市场状态',
          key: 'mktStas',
        },
        {
          title: '市场状态名称',
          key: 'mktStasName',
        },
        {
          title: '药品注册批件电子档案',
          key: 'drugRegAppvletrElecacs',
        },
        {
          title: '药品补充申请批件电子档案',
          key: 'splmAppyAppvletrFile',
        },
        {
          title: '国家医保药品目录备注',
          key: 'natHiDruglistMemo',
        },
        {
          title: '药品注册批件电子档案',
          key: 'drugRegAppvletrElecacs',
        },
        {
          title: '国家医保药品目录备注',
          key: 'natHiDruglistMemo',
        },
        {
          title: '基本药物标志',
          key: 'basMednFlag',
        },
        {
          title: '增值税调整药品标志',
          key: 'advaltaxAdjmDrugFlag',
        },
        {
          title: '增值税调整药品名称',
          key: 'advaltaxAdjmDrugName',
        },
        {
          title: '上市药品目录集药品',
          key: 'lstdDruglistDrug',
        },
        {
          title: '医保谈判药品标志',
          key: 'hiNegoDrugFlag',
        },
        {
          title: '医保谈判药品名称',
          key: 'hiNegoDrugName',
        },
        {
          title: '卫健委药品编码',
          key: 'nhcDrugCodg',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
      ],
      // 中草药药品目录信息【11302】中草药药品目录查询
      chineseDrugList: [
        {
          title: '医疗目录编码',
          key: 'medListCodg',
        },
        {
          title: '中草药名称',
          key: 'tcmherbName',
        },
        {
          title: '单复方标志',
          key: 'cpndFlag',
        },
        {
          title: '质量等级',
          key: 'qltReg',
        },
        {
          title: '药用部位',
          key: 'medPart',
        },
        {
          title: '安全计量',
          key: 'safeMtr',
        },
        {
          title: '常规用法',
          key: 'cnvlUsed',
        },
        {
          title: '性味',
          key: 'natfla',
        },
        {
          title: '归经',
          key: 'mertpm',
        },
        {
          title: '品种',
          key: 'cat',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
        {
          title: '中草药年份',
          key: 'tcmherbYear',
        },
      ],
      // 耗材目录信息【11305】耗材目录查询
      consumableList: [
        {
          title: '医疗目录编码',
          key: 'medListCodg',
        },
        {
          title: '版本名称',
          key: 'verName',
        },
        {
          title: '医疗器械唯一标识码',
          key: 'udi',
        },
        {
          title: '医保通用名代码',
          key: 'hiGennameCode',
        },
        {
          title: '医保通用名',
          key: 'hiGenname',
        },
        {
          title: '产品型号',
          key: 'prodMol',
        },
        {
          title: '规格代码',
          key: 'specCode',
        },
        {
          title: '规格',
          key: 'spec',
        },
        {
          title: '耗材分类',
          key: 'mcsType',
        },
        {
          title: '规格型号',
          key: 'specMol',
        },
        {
          title: '材质代码',
          key: 'matlCode',
        },
        {
          title: '耗材材质',
          key: 'mcsMatl',
        },
        {
          title: '包装规格',
          key: 'pacspec',
        },
        {
          title: '包装数量',
          key: 'pacCnt',
        },
        {
          title: '产品包装材质',
          key: 'prodPacmatl',
        },
        {
          title: '包装单位',
          key: 'pacunt',
        },
        {
          title: '产品转换比',
          key: 'prodConvrat',
        },
        {
          title: '最小使用单位',
          key: 'minUseunt',
        },
        {
          title: '生产地类别名称',
          key: 'prodplacTypeName',
        },
        {
          title: '产品标准',
          key: 'prodstrd',
        },
        {
          title: '产品有效期',
          key: 'prodexpy',
        },
        {
          title: '性能结构与组成',
          key: 'perfStruComp',
        },
        {
          title: '适用范围',
          key: 'apbScp',
        },
        {
          title: '产品使用方法',
          key: 'prodIstr',
        },
        {
          title: '产品图片编号',
          key: 'prodImgNo',
        },
        {
          title: '产品质量标准',
          key: 'prodQltStd',
        },
        {
          title: '说明书',
          key: 'manl',
        },
        {
          title: '其他证明材料',
          key: 'oth_cert_matl',
        },
        {
          title: '专机专用标志',
          key: 'spedFlag',
        },
        {
          title: '专机名称',
          key: 'spedName',
        },
        {
          title: '组套名称',
          key: 'combName',
        },
        {
          title: '机套标志',
          key: 'combName',
        },
        {
          title: '机套标志',
          key: 'caseFlag',
        },
        {
          title: '限制使用标志',
          key: 'lmtUsedFlag',
        },
        {
          title: '医保限用范围',
          key: 'hiLmtScp',
        },
        {
          title: '最小销售单位',
          key: 'minSalunt',
        },
        {
          title: '高值耗材标志',
          key: 'highvalMcsFlag',
        },
        {
          title: '医用材料分类代码',
          key: 'matlTypeCode',
        },
        {
          title: '植入材料和人体器官标志',
          key: 'imptMatlHmorgnFlag',
        },
        {
          title: '灭菌标志',
          key: 'stlzFlag',
        },
        {
          title: '灭菌标志名称',
          key: 'stlzFlagName',
        },
        {
          title: '植入或介入类标志',
          key: 'imptItvtClssFlag',
        },
        {
          title: '植入或介入类名称',
          key: 'imptItvtClssName',
        },
        {
          title: '一次性使用标志名称',
          key: 'dspoUsedFlagName',
        },
        {
          title: '注册备案人名称',
          key: 'regerName',
        },
        {
          title: '开始日期',
          key: 'begndate',
        },
        {
          title: '结束日期',
          key: 'enddate',
        },
        {
          title: '医疗器械管理类别',
          key: 'medEquMgtType',
        },
        {
          title: '医疗器械管理类别名称',
          key: 'medEquMgtTypeName',
        },
        {
          title: '注册备案号',
          key: 'regFilNo',
        },
        {
          title: '注册备案产品名称',
          key: 'regFilProdName',
        },
        {
          title: '结构及组成',
          key: 'struComp',
        },
        {
          title: '其他内容',
          key: 'othCont',
        },
        {
          title: '批准日期',
          key: 'aprvDate',
        },
        {
          title: '注册备案人住所',
          key: 'regerAddr',
        },
        {
          title: '注册证有效期开始时间',
          key: 'regcertExpyBegntime',
        },
        {
          title: '注册证有效期结束时间',
          key: 'regcertExpyEndtime',
        },
        {
          title: '生产企业代码',
          key: 'prodentpCode',
        },
        {
          title: '生产企业名称',
          key: 'prodentpName',
        },
        {
          title: '生产地址',
          key: 'manuAddr',
        },
        {
          title: '代理人企业',
          key: 'agntEntp',
        },
        {
          title: '代理人企业地址',
          key: 'agntEntpAddr',
        },
        {
          title: '生产国或地区',
          key: 'manuNatRegn',
        },
        {
          title: '售后服务机构',
          key: 'aftsalSerins',
        },
        {
          title: '注册或备案证电子档案',
          key: 'regFilElecFile',
        },
        {
          title: '产品影像',
          key: 'prodImg',
        },
        {
          title: '有效标志',
          key: 'valiFlag',
        },
      ],
    };
  },
  methods: {
    handlerChange(obj) {
      const {
        lmtpric, selfpayArray, hilist, tcmpat, tcmherb, mcsinfo,
      } = obj;
      this.limitedPriceObj = lmtpric || {};
      this.selfPercentArray = selfpayArray || [];
      this.insDirectoryObj = hilist || {};

      switch (this.query.type) {
        case 1:
          this.config.drugObj = tcmpat || {};
          this.config.drugLableName = '西药药品目录信息';
          this.config.drugList = this.drugList;
          break;
        case 2:
          this.config.drugObj = mcsinfo || {};
          this.config.drugLableName = '耗材目录信息';
          this.config.drugList = this.consumableList;
          break;
        case 3:
          this.config.drugObj = tcmherb || {};
          this.config.drugLableName = '中草药药品目录信息';
          this.config.drugList = this.chineseDrugList;
          break;
        default:
          break;
      }
    },
    toSearch() {
      if (!this.query.medListCodg) {
        this.$Message.error('请填写医疗目录编码');
        return;
      }
      this.getData(this.query);
    },
    clear() {
      this.query = {
        medListCodg: null,
        type: 1,
      };
    },
    getData(params) {
      healthInsManage.getDrugInfo(params).then((res) => {
        if (res.data.status === 200) {
          if (res.data && res.data.data && res.data.data instanceof Object) {
            this.handlerChange(res.data.data);
            return;
          }
          this.$Message.error('数据格式不对');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .con {
    width: 98%;
    background-color: #ffffff;
    padding: 30px;
    .everyInfo {
      width: 32%;
      display: inline-block;
      margin-top: 10px;
      cursor: pointer;
    }
    /deep/ .ivu-tooltip-rel {
      max-width: 281px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
